import React from "react";
import './Loader.css';

function Loader({ theme, title, message }) {
    return (
        <div className={`loaderContainer ${theme || ''}`}>
            <div className="loader">
                <div className="loader-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring reverse"></div>
                </div>
                <div className="loader-content">
                    {title && <h4>{title}</h4>}
                    {message && <p>{message}</p>}
                </div>
            </div>
            <div className="dark-overlay"></div>
        </div>
    );
}

export default Loader;
